import { waitForDOMContentLoaded } from "./async-utils";
import { store } from "./store-instance";
import configs from "./configs";

// NOTE these should be synchronized with the top of shared.scss
const DEFAULT_ACTION_COLOR = "#FF3464";
const DEFAULT_ACTION_COLOR_LIGHT = "#FF74A4";

let DEFAULT_COLORS = {
  "action-color": DEFAULT_ACTION_COLOR,
  "action-label-color": DEFAULT_ACTION_COLOR,
  "action-color-disabled": DEFAULT_ACTION_COLOR_LIGHT,
  "action-color-highlight": DEFAULT_ACTION_COLOR_LIGHT,
  "action-text-color": "#FFFFFF",
  "action-subtitle-color": "#F0F0F0",
  "notice-background-color": "#2F80ED",
  "notice-text-color": "#FFFFFF",
  "favorited-color": "#FFC000",
  "nametag-color": "#000000",
  "nametag-volume-color": "#7ED320",
  "nametag-text-color": "#FFFFFF",
  "nametag-border-color": "#7ED320",
  "nametag-border-color-raised-hand": "#FFCD74"
};

window.SAT = {};
window.SAT.Utils = {
  locale: navigator.language.toLowerCase().indexOf("fr") > -1 ? "fr" : "en"
};
window.SAT.themes = { customThemeChecked: false, forceDOMLoaded: false };

const themeQs = new URLSearchParams(location.search);
const themeDefaultRoomId = configs.feature("default_room_id");
const themeFoundHubID =
  window.APP != null && window.APP.hub != null && window.APP.hub.hub_id != null
    ? window.APP.hub.hub_id
    : document.location.pathname.substring(1).split("/")[0];

const themeTempHubID =
  themeQs.get("hub_id") ||
  (document.location.pathname === "/" && themeDefaultRoomId ? themeDefaultRoomId : themeFoundHubID);

const fetchRoomThemes = async hubID => {
  return new Promise(resolve => {
    try {
      const themesURL = `${configs.INJECTION_URL}/hubs/theme/${hubID}`;
      // console.log("fetchRoomThemes", themesURL);
      fetch(themesURL, { method: "get" })
        .then(function(body) {
          return body.text();
        })
        .catch(function(err) {
          console.warn(err);
          return resolve(false);
        })
        .then(function(data) {
          // console.log(data);
          if (data) {
            const results = JSON.parse(data);
            const hasCustomTheme = results.hasCustomTheme;
            const hasGlobalTheme = results.hasGlobalCustomTheme;
            window.SAT.useCustomEntry = results.useCustomEntry;
            window.SAT.useDynamicCustomEntry = results.useDynamicCustomEntry;
            window.SAT.useCustomSpacesMenu = results.useCustomSpacesMenu;
            if (hasCustomTheme) {
              window.SAT.themes.customTheme = results.themeColors;
              //console.log("room theme configs found ");
              //console.log(results.themeColors);
              return resolve(true);
            } else {
              if (hasGlobalTheme) {
                window.SAT.themes.customTheme = results.globalThemeColors.themeColors;
                //console.log("global theme configs found ");
                //console.log(results.globalThemeColors.themeColors);
                return resolve(true);
              }
              //console.log("NO theme found whatsoever");
              return resolve(false);
            }
          } else {
            console.warn("NO DATA FOUND ON RESPONSE BODY");
            return resolve(false);
          }
        })
        .catch(function(err) {
          console.warn(err);
          return resolve(false);
        });
    } catch (err) {
      console.warn(err);
      return resolve(false);
    }
  });
};


function getThemeColor(name) {
  let customThemeVariable = null;
  if (window.SAT.themes && window.SAT.themes.roomThemeDefined && window.SAT.themes.customTheme) {
    if (window.SAT.themes.customTheme?.[name]) {
      customThemeVariable = window.SAT.themes.customTheme[name];
    }
  }
  if (customThemeVariable) {
    return customThemeVariable;
  }

  const themeId = window.APP?.store?.state?.preferences?.theme;

  const theme =
    (themeId && configs.APP_CONFIG?.theme?.themes?.find(theme => theme.id === themeId)) ||
    configs.APP_CONFIG?.theme?.themes?.find(theme => theme.default === true);
  if (theme?.variables?.[name]) {
    return theme.variables[name];
  }

  return DEFAULT_COLORS[name];
}

function activateTheme() {
  const actionColor = getThemeColor("action-color");
  const actionHoverColor = getThemeColor("action-color-highlight");

  if (document.querySelector("#rounded-text-button")) {
    // NOTE, using the object-based {} setAttribute variant in a-frame
    // seems to not work in Firefox here -- the entities with the mixins are not
    // updated.
    document
      .querySelector("#rounded-text-button")
      .setAttribute(
        "text-button",
        `textHoverColor: ${actionHoverColor}; textColor: ${actionColor}; backgroundColor: #fff; backgroundHoverColor: #aaa;`
      );

    document
      .querySelector("#rounded-button")
      .setAttribute(
        "text-button",
        `textHoverColor: ${actionHoverColor}; textColor: ${actionColor}; backgroundColor: #fff; backgroundHoverColor: #aaa;`
      );

    document
      .querySelector("#rounded-text-action-button")
      .setAttribute(
        "text-button",
        `textHoverColor: #fff; textColor: #fff; backgroundColor: ${actionColor}; backgroundHoverColor: #aaa`
      );

    document
      .querySelector("#rounded-action-button")
      .setAttribute(
        "text-button",
        `textHoverColor: #fff; textColor: #fff; backgroundColor: ${actionColor}; backgroundHoverColor: #aaa`
      );
  }
}

const onStoreChanged = (function() {
  let themeId;
  return function onStoreChanged() {
    const newThemeId = window.APP?.store?.state?.preferences?.theme;
    if (themeId !== newThemeId) {
      themeId = newThemeId;
      activateTheme();
    }
  };
})();

function onColorsChanged(data) {
  DEFAULT_COLORS = data.detail;
  console.log("onColorsChanged", DEFAULT_COLORS);
  activateTheme();
  const event = new CustomEvent("themeShifterChanged", { detail: "themeShifterChanged" });
  window?.APP?.store?.dispatchEvent(event);

  const cameraEvent = new CustomEvent("labelChange", { detail: `${DEFAULT_COLORS["action-color"]}` });
  window?.dispatchEvent(cameraEvent);
}

const applyThemeAssets = () => {
  if (document.body && document.body.classList) {
    if (configs.APP_CONFIG && configs.APP_CONFIG.theme && configs.APP_CONFIG.theme["dark-theme"]) {
      document.body.classList.add("dark-theme");
    } else {
      document.body.classList.add("light-theme");
    }
  }
  activateTheme();
  window.APP?.store?.addEventListener("statechanged", onStoreChanged);
  window.APP?.store?.addEventListener("constchanged", onColorsChanged);
};

if (!window.SAT.themes.roomThemeDefined && themeTempHubID) {
  fetchRoomThemes(themeTempHubID)
    .then(res => {
      // console.log(res);
      window.SAT.themes.customThemeChecked = true;
      window.SAT.themes.roomThemeDefined = res;
      applyThemeAssets();
    })
    .catch(() => {
      window.SAT.themes.customThemeChecked = true;
      window.SAT.themes.roomThemeDefined = false;
      applyThemeAssets();
    });
}

waitForDOMContentLoaded().then(() => {
  if (window.SAT.themes.customThemeChecked) {
    applyThemeAssets();
  } else {
    window.SAT.themes.forceDOMLoaded = true;
  }
});

const config = (() => {
  let config = process.env.APP_CONFIG;

  // Storybook includes environment variables as a string
  // https://storybook.js.org/docs/react/configure/environment-variables
  if (!config && process.env.STORYBOOK_APP_CONFIG) {
    config = JSON.parse(process.env.STORYBOOK_APP_CONFIG);
  }

  if (!config) {
    config = window.APP_CONFIG;
  }

  if (config?.theme?.error) {
    console.error(
      `Custom themes failed to load.\n${config.theme.error}\nIf you are an admin, reconfigure your themes in the admin panel.`
    );
  }

  return config;
})();

const themes = config?.theme?.themes || [];

function getDarkModeQuery() {
  // window.matchMedia is not available when this module is imported in node.js,
  // which happens when using `npm run login` for Hubs Cloud customization.
  // So we return a dummy MediaQueryList instead.
  if (typeof window.matchMedia !== "undefined") {
    return window.matchMedia("(prefers-color-scheme: dark)");
  } else {
    return { matches: false, addEventListener: () => {}, removeEventListener: () => {} };
  }
}

function registerDarkModeQuery(changeListener) {
  const darkModeQuery = getDarkModeQuery();

  // This is a workaround for old Safari.
  // Prior to Safari 14, MediaQueryList is based on EventTarget, so you must use
  // addListener() and removeListener() to observe media query lists.
  // https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/addListener
  // We may remove this workaround when no one will use Safari 13 or before.
  if (darkModeQuery.addEventListener) {
    darkModeQuery.addEventListener("change", changeListener);
  } else {
    darkModeQuery.addListener(changeListener);
  }

  const removeListener = () => {
    if (darkModeQuery.removeEventListener) {
      darkModeQuery.removeEventListener("change", changeListener);
    } else {
      darkModeQuery.removeListener(changeListener);
    }
  };

  return [darkModeQuery, removeListener];
}

function getDefaultTheme() {
  return themes.find(t => t.default) || themes[0];
}

function tryGetTheme(themeId) {
  if (!Array.isArray(themes)) return;

  const theme = themeId && themes.find(t => t.id === themeId);
  if (theme) {
    return theme;
  } else {
    const darkMode = getDarkModeQuery().matches;
    return (darkMode && themes.find(t => t.darkModeDefault)) || getDefaultTheme();
  }
}

function getCurrentTheme() {
  const preferredThemeId = store.state?.preferences?.theme;
  return tryGetTheme(preferredThemeId);
}

function updateTextButtonColors() {
  const actionColor = getThemeColor("action-color");
  const actionHoverColor = getThemeColor("action-color-highlight");

  if (document.querySelector("#rounded-text-button")) {
    // NOTE, using the object-based {} setAttribute variant in a-frame
    // seems to not work in Firefox here -- the entities with the mixins are not
    // updated.
    document
      .querySelector("#rounded-text-button")
      .setAttribute(
        "text-button",
        `textHoverColor: ${actionHoverColor}; textColor: ${actionColor}; backgroundColor: #fff; backgroundHoverColor: #aaa;`
      );

    document
      .querySelector("#rounded-button")
      .setAttribute(
        "text-button",
        `textHoverColor: ${actionHoverColor}; textColor: ${actionColor}; backgroundColor: #fff; backgroundHoverColor: #aaa;`
      );

    document
      .querySelector("#rounded-text-action-button")
      .setAttribute(
        "text-button",
        `textHoverColor: #fff; textColor: #fff; backgroundColor: ${actionColor}; backgroundHoverColor: ${actionHoverColor}`
      );

    document
      .querySelector("#rounded-action-button")
      .setAttribute(
        "text-button",
        `textHoverColor: #fff; textColor: #fff; backgroundColor: ${actionColor}; backgroundHoverColor: ${actionHoverColor}`
      );
  }
}

function applyThemeToBody() {
  const theme = getCurrentTheme();
  document.body.setAttribute("data-theme", theme.name.toLowerCase().includes("dark") ? "dark" : "light");
}

function onThemeChanged(listener) {
  store.addEventListener("themechanged", listener);
  const [_darkModeQuery, removeDarkModeListener] = registerDarkModeQuery(listener);

  return () => {
    store.removeEventListener("themechanged", listener);
    removeDarkModeListener();
  };
}

waitForDOMContentLoaded().then(() => {
  if (process.env.NODE) {
    // We're running in node.js, which happens when "npm run login" is used, for example,
    // so don't bother doing anything UI related.
    return;
  }

  // Set initial theme
  const theme = getCurrentTheme();
  if (theme && theme.name.toLowerCase().includes("dark")) {
    document.body.setAttribute("data-theme", "dark");
  } else {
    document.body.setAttribute("data-theme", "light");
  }

  updateTextButtonColors();
  onThemeChanged(() => {
    updateTextButtonColors();
    applyThemeToBody();
  });
});

function applyThemeToTextButton(el, highlighted) {
  el.setAttribute(
    "text-button",
    "backgroundColor",
    highlighted ? getThemeColor("action-color-highlight") : getThemeColor("action-color")
  );
  el.setAttribute(
    "text-button",
    "backgroundHoverColor",
    highlighted ? "#aaa" : getThemeColor("action-color-highlight")
  );
}

export {
  applyThemeToTextButton,
  getCurrentTheme,
  getDefaultTheme,
  getThemeColor,
  onThemeChanged,
  applyThemeToBody,
  registerDarkModeQuery,
  themes,
  tryGetTheme
};